import React, { useState, useRef } from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import PhoneInput from './PhoneInput'
import PhoneSendCode from './PhoneSendCode'
import FormInput from './FormInput'
import Spinner from './Spinner'
import { getAccount, postPhoneUpdateRequest, postPhoneUpdateVerify, deletePhoneNumber } from '../actions/api'
import { resetPhoneUpdate } from '../actions/utils'
import { profileSelector } from '../reducers/profile'
import { phoneRequestSelector } from '../reducers/phone.request'
import find from 'lodash/find'
import get from 'lodash/get'

import '../styles/form.scss'

function SettingsPhone({
  country,
  defaultPhone,
  phone,
  setPhone,
  phoneRequest,
  getAccount,
  postPhoneUpdateRequest,
  postPhoneUpdateVerify,
  resetPhoneUpdate,
  getCodeRef
}) {
  const [sendingCode, setSendingCode] = useState(false)
  const [codeСheck, setCodeCheck] = useState(false)
  const [phoneError, setPhoneError] = useState(null)

  const handlePhoneChange = event => {
    setPhone(event.target.value)
    setPhoneError(null)
  }

  const handleSendCodeClick = async () => {
    setPhoneError(null)
    const parsePhoneNumber = parsePhoneNumberFromString(phone, country.iso2.toUpperCase())
    if (Boolean(parsePhoneNumber)) {
      const phone_number = parsePhoneNumber.number
      try {
        setSendingCode(true)
        const response = await postPhoneUpdateRequest({ phone_number })
        setSendingCode(false)
        if (response.payload.errors && response.payload.errors.length > 0) {
          if (find(response.payload.errors, { type: 'phone' })) {
            setPhoneError(find(response.payload.errors, { type: 'phone' }))
          }
        } else if (response.payload.error || response.error) {
          setPhoneError(String(response.payload.error || response.payload.message || response.error))
        }
        if (response.payload.action === 'verify_update') {
          setPhoneError(null)
          setCodeCheck(true)
        }
      } catch (error) {
        setSendingCode(false)
        setPhoneError(String(error))
      }
    } else {
      setPhoneError(
        'Телефон не распознан — вряд ли у нас получится отправить на него СМС. Пожалуйста, проверьте введенный номер телефона'
      )
    }
  }

  const [verificationCode, setVerificationCode] = useState('')
  const [verificationCodeLoading, setVerificationCodeLoading] = useState(false)
  const [verificationCodeSuccess, setVerificationCodeSuccess] = useState(false)
  const [verificationCodeError, setVerificationCodeError] = useState(null)

  const handleVerificationCodeChange = async event => {
    setVerificationCodeError(null)
    setVerificationCode(event.target.value)
    if (verificationCode && event.target.value.length === 4) {
      try {
        setVerificationCodeLoading(true)
        const response = await postPhoneUpdateVerify({
          phone_number: phoneRequest.phone_number,
          verification_code: event.target.value
        })
        setVerificationCodeLoading(false)
        if (response.payload.errors && response.payload.errors.length > 0) {
          if (find(response.payload.errors, { type: 'code' })) {
            setVerificationCodeError(find(response.payload.errors, { type: 'code' }))
          }
        } else if (response.payload.error || response.error) {
          setVerificationCodeError(String(response.payload.error || response.payload.message || response.error))
        } else if (response.payload.action === 'success') {
          setVerificationCodeSuccess(true)
          setTimeout(async () => {
            await getAccount()
            setVerificationCodeSuccess(false)
            setVerificationCode('')
            setCodeCheck(false)
            resetPhoneUpdate()
          }, 1000)
        }
      } catch (error) {
        setVerificationCodeLoading(false)
        setVerificationCodeError(String(error))
      }
    }
  }

  return (
    <>
      <div className="account-form">
        <div className="account-form__container">
          <span className="account-form__label account-form__label--settings">Телефон</span>
          <input
            className={classnames('account-form__input account-form__input--country-code', {
              'account-form__input--error': Boolean(phoneError)
            })}
            type="tel"
            value={`+${country.dialCode}`}
            disabled
          />
          <PhoneInput
            className={classnames('account-form__input account-form__input--phone', {
              'account-form__input--error': Boolean(phoneError)
            })}
            country={country}
            value={phone}
            onChange={handlePhoneChange}
            disabled={codeСheck}
          />
          {phone !== defaultPhone && !verificationCodeSuccess && phone.length !== 0 && phone !== ' ' && (
            <PhoneSendCode
              nextAttempt={phoneRequest.nextAttempt}
              onClick={handleSendCodeClick}
              sending={sendingCode}
              getCodeRef={getCodeRef}
            />
          )}
        </div>
        <div className="account-form__phone-remark">
          К&nbsp;сожалению, пока что мы&nbsp;можем отправлять СМС только на&nbsp;российские номера
        </div>
        {phoneError && (
          <div className="account-form__error account-form__error--input account-form__error--settings">
            {get(phoneError, 'message') ? get(phoneError, 'message') : String(phoneError)}
          </div>
        )}
      </div>
      {codeСheck && (
        <FormInput
          label="Код из СМС"
          value={verificationCode}
          onChange={handleVerificationCodeChange}
          maxLength={4}
          error={verificationCodeError}
          disabled={verificationCodeSuccess}
          isSettings
          isConfirmCode>
          <div
            className={classnames(
              'account-form__code-icon',
              { 'account-form__code-icon--success': verificationCodeSuccess },
              { 'account-form__code-icon--error': verificationCodeError }
            )}>
            {verificationCodeLoading && <Spinner isSmall />}
          </div>
        </FormInput>
      )}
    </>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector,
  phoneRequest: phoneRequestSelector
})

export default connect(mapStateToProps, {
  getAccount,
  postPhoneUpdateRequest,
  postPhoneUpdateVerify,
  resetPhoneUpdate
})(SettingsPhone)
